import { type FeatureModule } from '@store/features/types';

import clinicDocChatReducer from './clinicDocChatSlice';
import { clinicDocStreamingApi } from './clinicDocStreamingApi';

export const clinicDocumentsFeature: FeatureModule = {
  id: 'clinicDocuments',
  name: 'Clinic Documents',
  dependencies: [],
  reducers: {
    'clinicDocuments/chat': clinicDocChatReducer,
    [clinicDocStreamingApi.reducerPath]: clinicDocStreamingApi.reducer,
  },
  middleware: [clinicDocStreamingApi.middleware],
  persistence: { enabled: false },
  sync: { enabled: false },
  setup: _store => {},
  cleanup: _store => {},
};
